export default __webpack_public_path__ + "static/media/horizontales-HC3.09d98341.jpg";